import React from 'react';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import BootstrapSpinner from '../bootstrap-spinner/BootstrapSpinner';
import './loading-modal.css';

export const LoadingModal = (props) => {
  const { isOpen } = props;

  return (
    <>
      {isOpen && (
        <DialogComponent
          cssClass="e-loading-dialog"
          isModal={true}
          width="500px"
        >
          <div style={{ height: '500px' }}>
            <BootstrapSpinner />
          </div>
        </DialogComponent>
      )}
    </>
  );
};
